export function mergeArrays<T>(
  getIdentifier: (item: T) => string,
  ...arrays: T[][]
) {
  const result: T[] = [];
  const ids: string[] = [];
  for (const array of arrays) {
    for (const item of array) {
      const id = getIdentifier(item);

      if (!ids.includes(id)) {
        ids.push(id);
        result.push(item);
      }
    }
  }

  return result;
}
